import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ApplicationConfig, provideZoneChangeDetection, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ConfigService, errorInterceptor, loadingInterceptor, tokenInterceptor } from 'core';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideToastr } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { providePrimeNG } from 'primeng/config';
import { purplePreset } from 'core/themes/primeng-presets/custom-preset';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

const initializerConfigFn = (): any => {
  const configService = inject(ConfigService);
  return configService.loadAppConfig();
};

export const appConfig: ApplicationConfig = {
  providers: [
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
    provideAnimationsAsync(),
    provideAppInitializer(initializerConfigFn),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([tokenInterceptor, loadingInterceptor, errorInterceptor])),
    provideTranslateService({
      fallbackLang: environment.defaultLanguage,
      loader: provideTranslateHttpLoader({ prefix: 'assets/i18n/', suffix: '.json', useHttpBackend: true /* Bypasses HTTP interceptors*/ })
    }),
    provideRouter(routes, withViewTransitions()),
    providePrimeNG({
      theme: {
        preset: purplePreset,
        options: {
          darkModeSelector: '.app-dark'
        }
      },
      ripple: true
    }),
    provideToastr({
      toastClass: 'ngx-toastr',
      onActivateTick: true,
      maxOpened: 1,
      autoDismiss: true
    })
  ]
};
